import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../contexts/LoadingContext';
import { scrollToTop } from '../utils/scrollUtils';

export const useTransition = () => {
  const navigate = useNavigate();
  const { setGlobalLoadingState } = useLoading();

  const navigateWithTransition = useCallback((path, options = {}) => {
    const { 
      delay = 100, 
      scrollToTopFirst = false, 
      replace = false,
      showLoading = true 
    } = options;

    if (showLoading) {
      setGlobalLoadingState(true);
    }

    if (scrollToTopFirst) {
      scrollToTop();
    }

    setTimeout(() => {
      navigate(path, { replace });
      
      // Clear loading state after navigation
      if (showLoading) {
        setTimeout(() => {
          setGlobalLoadingState(false);
        }, 300);
      }
    }, delay);
  }, [navigate, setGlobalLoadingState]);

  const preloadRoute = useCallback((path) => {
    // Create a link element to trigger route preloading
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = path;
    document.head.appendChild(link);
    
    // Clean up after a short delay
    setTimeout(() => {
      document.head.removeChild(link);
    }, 1000);
  }, []);

  return {
    navigateWithTransition,
    preloadRoute
  };
};

export default useTransition;
